import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { PrManagersPersonaPageBG } from "@/components/site/PrManagersPersonaPageBG";
import { PR_MANAGERS_META_DESCRIPTION_BG } from "@/content/meta/PrManagersPersonaPageBG";

export const Route = createFileRoute("/bg/who-we-help/pr-managers")({
  head: () => ({
    meta: [
      { title: "Медийно разузнаване за PR мениджъри | Perceptica" },
      { name: "description", content: PR_MANAGERS_META_DESCRIPTION_BG },

      { property: "og:title", content: "Медийно разузнаване за PR мениджъри | Perceptica" },
      { property: "og:description", content: PR_MANAGERS_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медийно разузнаване за PR мениджъри | Perceptica" },
      { name: "twitter:description", content: PR_MANAGERS_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/who-we-help/pr-managers" },
      ...ogImageMeta("bg", "/who-we-help/pr-managers"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/who-we-help/pr-managers" }),
  }),
  component: PrManagersPersonaPageBG,
});
